// eslint-disable-next-line import/prefer-default-export
export const RECIPE_FILTERS_DATA = {
	meals: {
		name: 'meal',
		title: 'Meal',
	},
	seasons: {
		name: 'season',
		title: 'Season',
	},
	dishTypes: {
		name: 'dishType',
		title: 'Dish Type',
	},
	specialDiets: {
		name: 'specialDiet',
		title: 'Special Diet',
	},
	cookingMethods: {
		name: 'cookingMethod',
		title: 'Cooking Method',
	},
	cuisines: {
		name: 'cuisine',
		title: 'Cuisine',
	},
	occasions: {
		name: 'occasion',
		title: 'Occasion',
	},
};
